import React, {forwardRef, useImperativeHandle, useState} from 'react';
import {ControlGroup, InputGroup, Button, ButtonGroup} from '@blueprintjs/core';
import {IconNames} from '@blueprintjs/icons';
import {CopyToClipboard} from 'react-copy-to-clipboard';

import {generateWebhookToken, generateUrl} from './utils';
import {TRIGGER_SOURCE} from '../constants';

interface WebhookInputProps {
  data?: any | null;
  type: TRIGGER_SOURCE;
  uid?: string;
}


const WebhookInput = forwardRef(({
  data = null,
  type,
  uid,
}: WebhookInputProps, ref: any) => {
  const [token, setToken] = useState<string>(data?.token || generateWebhookToken());
  const [url, setUrl] = useState<string>(generateUrl(uid, type, token));

  useImperativeHandle(ref, () => ({
    getValue() {
      return token;
    }
  }));

  const changeUrl = () => {
    const newToken = generateWebhookToken();
    setToken(newToken);
    setUrl(generateUrl(uid, type, newToken));
  }

  return (
    <div className="webhook-input">
      <InputGroup
        value={url}
        fill={true}
        onChange={(e: any) => setUrl(e.target.value)}
        rightElement={
          <ButtonGroup>
            <Button icon={IconNames.REFRESH} title="Refresh token" onClick={changeUrl}/>
            <CopyToClipboard text={url}>
              <Button icon={IconNames.DUPLICATE} text="Copy"/>
            </CopyToClipboard>
          </ButtonGroup>
        }
      />
      <div className="helper-text">Anyone with this URL can trigger an execution of the workflow.
        Be careful when sharing.</div>
    </div>
  );
});

export default WebhookInput;
